// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
// import "@babel/polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@state/store'
import './plugins/index'
import { createVuetifyInstance } from './plugins/vuetify'
import PortalVue from 'portal-vue'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import 'typeface-poppins'

// import "./assets/sass/main.scss";
// import "./assets/css/base.css";
import vueDebounce from 'vue-debounce'
import closeOnEscMixin from './mixins/closeOnEscMixin'
import submitOnEnterMixin from './mixins/submitOnEnterMixin'

async function bootstrap() {
  const vuetify = await createVuetifyInstance()
  Vue.use(vuetify)
  const EventBus = new Vue()
  Vue.prototype.$eventBus = EventBus
  Vue.use(vueDebounce)
  Vue.use(PortalVue)
  
  Vue.mixin(closeOnEscMixin)
  Vue.mixin(submitOnEnterMixin)
  
  window.mapboxgl = mapboxgl
  Vue.config.productionTip = false
  Vue.config.performance = true
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    vuetify,
    template: '<App/>'
  })
}

bootstrap()



// WEBPACK FOOTER //
// ./src/main.js